<template lang="pug">
    div
        Button(@click="isModalShow = true" :icon="buttonIcon" v-if="withIcon")
        Button(size="small" @click="isModalShow = true" :icon="buttonIcon" v-else)
            template(v-if="buttonText.length > 0")  {{ buttonText }}
        
        Modal(v-model="isModalShow" :title="title" :width="width")
            template(slot="header")
                span {{ title }}
                Tooltip(
                    v-if="showHint && hintText"
                    :content="hintText"
                    placement="right"
                    transfer
                )
                    Icon(type="ios-information-circle-outline")
                    template(slot="content")
                        div(:style="{whiteSpace: 'pre-line'}") {{ hintText }}
            div.poptipPreWrapper
                // 舊 JSON 顯示（預設）
                template(v-if="displayType === 'json'")
                    CopyText.poptipPreCopyButton(v-if="withCopyButton" :text="$options.filters.prettyJson(jsonData)")
                    pre.poptipPre(v-text="$options.filters.prettyJson(jsonData)")

                // 新 keyValue 顯示
                template(v-else-if="displayType === 'keyValue'")
                    div.kv-scroll-wrapper
                        Row(
                            v-for="(item, i) in rows"
                            :key="i"
                            type="flex"
                            align="top"
                            style="margin-bottom: 8px"
                        )
                            Col(span="8")
                                strong {{ item.label }}

                            Col(span="16" class="kv-value-col")
                                span(v-if="isPrimitive(item.value)")
                                    | {{ format(item.value) }}

                                span(v-else-if="Array.isArray(item.value)")
                                    | {{ item.value.join(', ') || '-' }}

                                pre(v-else)
                                    | {{ pretty(item.value) }}
            div(slot="footer")
                Button(type="primary" @click="isModalShow = false") {{ $t('global.close') }}
</template>
<script>
import CopyText from "@/components/CopyText";
export default {
    name: "JsonPoptip",
    props: {
        jsonData: { default: () => ({}) },
        title: { type: String, default: "title" },
        buttonText: { type: String, default: "顯示" },
        buttonIcon: { type: String, default: "" },
        withCopyButton: { type: Boolean, default: false },
        width: { type: [Number, String], default: "520"},

        // 標題旁的提示說明
        showHint: { type: Boolean, default: false },
        hintText: { type: String, default: "" },

        // 顯示模式
        displayType: {
            type: String,
            default: "json",
            validator: v => ["json", "keyValue"].includes(v)
        },
        
        // i18n key 前綴
        i18nPrefix: {
            type: String,
        }
    },
    components: { CopyText: CopyText },
    watch: {},
    created() {},
    data() {
        return {
            isModalShow: false
        };
    },
    methods: {
        isPrimitive: function(v) {
            return (
                typeof v === "string" ||
                typeof v === "number" ||
                typeof v === "boolean" ||
                v === null ||
                v === undefined
            );
        },
        format: function(v) {
            if (v === null || v === undefined || v === "") return "-";
            if (typeof v === "boolean") return v ? "true" : "false";
            return String(v);
        },
        pretty: function(v) {
            return JSON.stringify(v, null, 2);
        }
    },
    mounted() {},
    computed: {
        withIcon() {
            return this.$store.getters.getJsonPopTipConfig.withIcon;
        },
        rows() {
            if (this.displayType !== "keyValue") return [];

            const d = this.jsonData || {};
            if (typeof d !== "object") return [];

            return Object.keys(d).map(k => {
                const i18nKey = this.i18nPrefix
                    ? `${this.i18nPrefix}.${k}`
                    : k;

                const label = this.$t(i18nKey)
                    ? this.$t(i18nKey)
                    : k;

                return { label, value: d[k] };
            });
        }
    },
    filters: {
        prettyJson: function(value) {
            try {
                return typeof value == "object"
                    ? JSON.stringify(value, null, 2)
                    : JSON.stringify(JSON.parse(value), null, 2);
            } catch (err) {
                return value;
            }
        }
    }
};
</script>
<style scoped>
.poptipExplain {
    overflow: auto;
    white-space: normal;
    word-break: break-all;
    line-height: 25px;
    font-size: 14px;
}
.poptipPreWrapper {
    background-color: #eeeeee;
}
.poptipPreCopyButton {
    text-align: right;
    padding: 4px;
}
.poptipPre {
    overflow: auto;
    height: auto;
    max-height: 600px;
    word-break: normal !important;
    word-wrap: normal !important;
    white-space: pre !important;
}
</style>



// WEBPACK FOOTER //
// src/components/JsonPoptip.vue